import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index"
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import axios from 'axios'
import Vueaxios from 'vue-axios'
import './assets/styles/global-acomodar.css';
import  'bootstrap-icons/font/bootstrap-icons.css'

import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDp3Ud3SixagW8bJOwtosy5bBMB5JRNS_k', // No es necesario proporcionar una clave para la versión gratuita
    libraries: 'places',
  },
}),





// axios.defaults.baseURL
// axios.defaults.baseURL = "http://190.81.170.6:8086/api/"

axios.defaults.baseURL = "https://apitopas.gruposolimano.com.pe/api/"
 //pruebas locales
// axios.defaults.baseURL = "https://localhost:7059/api/"


// axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';

  

// axios.interceptors.response.use(config=>{
//   console.log(config)
// })
library.add(fas);
Vue.use(Vueaxios , axios)
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

  
new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
